import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Class from "./pages/Class.jsx";
import Exam from "./pages/Exam.jsx";
import Assignment from "./pages/Assigment.jsx";
import ContactUs from "./pages/Contact.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx"; 
// Naya Import (Make sure karein ke file components folder me ho)
import PopupForm from "./components/PopupForm"; 

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      
      {/* POPUP YAHAN ADD KIYA HAI */}
      <PopupForm /> 
      {/* Ye Routes ke bahar hai isliye har page ke upar float karega */}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/online-class" element={<Class />} />
        <Route path="/online-exams" element={<Exam />} />
        <Route path="/online-assignment" element={<Assignment />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;